module.exports = __webpack_public_path__ + "img/dsci0146.060087a7.jpg";